import { ReportReason } from '../types';

export const allReportReasons: ReportReason[] = [
    {
        label: 'insult',
        description: 'Die Bewertung ist beleidigend.',
    },
    { label: 'fakeReview', description: 'Die Bewertung ist gefälscht.' },
    { label: 'identical', description: 'Die Bewertung ist in identischem Wortlaut mehrfach vorhanden.' },
    {
        label: 'misspelling',
        description: 'Die Bewertung ist sprachlich nicht gut verfasst (viele Schreibfehler, Grammatik).',
    },
    { label: 'differentLanguage', description: 'Die Bewertung ist in einer anderen Sprache verfasst.' },
    { label: 'statementWrong', description: 'Die Bewertung ist inhaltlich falsch.' },
    { label: 'differentProduct', description: 'Die Bewertung bezieht sich nicht auf dieses Produkt.' },
    { label: 'others', description: 'Sonstiges' },
];
